<template>
    <div id="toast" :class="{ success, error, danger }">
      <font-awesome-icon
            :icon="['fas', error ? 'exclamation-triangle' : 'check-circle']"
            class="icon"
          ></font-awesome-icon>
      <slot />
    </div>
</template>

<script>
export default {
  props: {
    success: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/variables';
/* The snackbar - position it at the bottom and in the middle of the screen */
.success {
  background: @color-confirm-medium !important;
}
.error {
  background: @color-error-medium !important;
}
.danger {
  background: @color-warning-medium !important;
}
#toast {
  visibility: visible; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: @radius-small;
  padding: 20px;
  position: fixed;
  z-index: 100;
  align-self: center;
  top: 30px;
  display:flex;
}
.icon {
  margin-right: 20px;
  font-size: 20px;
}
</style>
